<template>
  <div id="imageDescList" class="w-full relative">
    <title-w-star :title="title" :titleColor="titleColor" :starIconObj="starIconObj" />

    <div class="absolute right-0 -z-10" style="width: 9.5vw" :style="'top: ' + starBackgroundRightObj.top" v-if="isShowStarBackgroundRight && Object.keys(starBackgroundRightObj).length != 0">
      <img :src="commonStore.getImgUrl(starBackgroundRightObj.componentName, starBackgroundRightObj.imgName, starBackgroundRightObj.imgFormat)" />
    </div>
    <div class="absolute left-0 -z-10" style="width: 9.5vw" :style="'bottom:' + starBackgroundLeftObj.bottom" v-if="isShowStarBackgroundLeft && Object.keys(starBackgroundLeftObj).length != 0">
      <img :src="commonStore.getImgUrl(starBackgroundLeftObj.componentName, starBackgroundLeftObj.imgName, starBackgroundLeftObj.imgFormat)" />
    </div>

    <div id="imageDescGroup" class="m-auto space-y-8" style="width: 60vw">
      <div v-for="(item, index) in imageDescList" :key="'imageDescList' + index" class="flex justify-between items-center">
        <!--if odd, img order changed-->
        <div :class="index % 2 === 0 ? 'order-1' : 'order-2'" style="width: 28vw">
          <img :src="commonStore.getImgUrl(item.image.componentName, item.image.imgName, item.image.imgFormat)" v-if="Object.keys(item.image).length != 0" />
        </div>
        <div :class="index % 2 === 0 ? 'order-2' : 'order-1'" style="width: 28vw">
          <div class="text-2xl font-bold" :style="'color:' + labelColor">{{ t(item.label) }}</div>
          <div class="text-lg" :style="'color:' + descColor" v-html="t(item.description)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => {});

import { toRefs } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleColor: {
    type: String,
    default: "#494949",
  },
  starIconObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  isShowStarBackgroundLeft: {
    type: Boolean,
    default: true,
  },
  isShowStarBackgroundRight: {
    type: Boolean,
    default: true,
  },
  starBackgroundLeftObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg', top: '30%',  }
  },
  starBackgroundRightObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg', bottom: '30%',  }
  },
  imageDescList: {
    type: Array,
    default: [],
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg', bottom: '30%',  }
  },
  labelColor: {
    type: String,
    default: "#494949",
  },
  descColor: {
    type: String,
    default: "#494949",
  },
});
//const { label } = toRefs(props);
</script>

<style>
</style>